export const URL_PATH = '/valve-configurator';
export const configuratorType = 'VALVE';
